(async function init() {
  const { bootstrap } = await import("./bootstrap");
  await bootstrap();
})();
export {};
